import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import UIModal, { ModalContent, ModalTitle } from "../modal";

const BasicModal = ({
  title = "Delete",
  children,
  size = "xs",
  open,
  onCancel,
  handleClose,
  saveButtonTitle = "Update",
  cancelButtonTitle = "Cancel",
  cancelButtonLoading = false,
  saveCallback = () => console.log("save clicked"),
  saveBtnLoading = false,
  saveBtnDisabled = false,
  saveBtnHidden = false,
  saveBtnStyles = {},
  cancelBtnStyles = {},
  modalFooterSx = {},
  cancelBtnHidden = false,
  customFooterButtons = undefined,
  whiteHeader = false,
  modalClasses = "",
  modalBodySx = {},
  modalSx = {},
  onEnter = () => console.log("onTransitionEnter"),
  onExit = () => console.log("onTransitionExited"),
  hideCloseIcon = false,
  disableEscapeKeyDown = false,
  showFooter = true,
  footerLoading = false,
  showFooterDivider = true,
}) => {
  return (
    <UIModal
      size={size}
      open={open}
      onClose={handleClose}
      saveButtonTitle={saveButtonTitle}
      saveCallback={saveCallback}
      saveBtnLoading={saveBtnLoading}
      saveBtnDisabled={saveBtnDisabled}
      saveBtnHidden={saveBtnHidden}
      saveBtnStyles={saveBtnStyles}
      cancelButtonTitle={cancelButtonTitle}
      onCancel={onCancel}
      cancelButtonLoading={cancelButtonLoading}
      cancelBtnHidden={cancelBtnHidden}
      cancelBtnStyles={cancelBtnStyles}
      customFooterButtons={customFooterButtons}
      modalClasses={modalClasses}
      modalSx={modalSx}
      modalFooterSx={modalFooterSx}
      onEnter={onEnter}
      onExit={onExit}
      disableEscapeKeyDown={disableEscapeKeyDown}
      showFooter={showFooter}
      footerLoading={footerLoading}
      showFooterDivider={showFooterDivider}
    >
      <ModalTitle
        handleClose={handleClose}
        whiteHeader={whiteHeader}
        hideCloseIcon={hideCloseIcon}
      >
        <Typography
          variant="h4"
          sx={{ fontSize: "1.2rem", fontWeight: "500" }}
          color={"custom.header_text"}
        >
          {title}
        </Typography>
      </ModalTitle>
      <ModalContent style={{ padding: "3rem", ...modalBodySx }}>
        {children}
      </ModalContent>
    </UIModal>
  );
};

export default BasicModal;
